import Swal from 'sweetalert2';

const Lexique = {
  survey: 'enquête',
  company: 'entreprise',
  user: 'utilisateur',
  question: 'question',
};

const defaultToast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
});

function capitalise(str) {
  return str && typeof str === 'string'
    ? str.charAt(0).toUpperCase() + str.slice(1)
    : str;
}

export default {
  lexique: Lexique,

  // Generic toasts
  toastSuccess(message) {
    defaultToast.fire({ icon: 'success', title: message });
  },
  toastError(message) {
    defaultToast.fire({ icon: 'error', title: message });
  },
  toastInfo(message) {
    defaultToast.fire({ icon: 'info', title: message });
  },

  // Alerts
  alertSuccess(title = 'Succès', message = '') {
    return Swal.fire({ icon: 'success', title, text: message });
  },
  alertError(title = 'Erreur', message = '') {
    return Swal.fire({ icon: 'error', title, text: message });
  },

  // Confirm dialog
  //
  // `denyText` ouvre une troisieme issue. Une question comme « vous avez des
  // modifications non enregistrees » en a trois - enregistrer, abandonner,
  // rester - et la reduire a deux forcerait a choisir entre perdre le travail
  // et ne pas pouvoir revenir en arriere. Le resultat se lit alors sur
  // `isConfirmed` / `isDenied` / `isDismissed`.
  confirm(title, text, options = {}) {
    return Swal.fire({
      title,
      text,
      icon: options.icon || 'question',
      showCancelButton: true,
      showDenyButton: !!options.denyText,
      confirmButtonText: options.confirmText || 'Oui',
      denyButtonText: options.denyText,
      cancelButtonText: options.cancelText || 'Annuler',
      // Trois boutons ne tiennent pas en ligne sans se bousculer.
      ...(options.denyText ? { reverseButtons: false } : {}),
    });
  },

  // Helpers for common CRUD messages in French
  successAction(action, entityKey = 'survey', extra = '') {
    const entity = Lexique[entityKey] || entityKey;
    const verb =
      action === 'delete'
        ? 'supprimée'
        : action === 'create'
          ? 'créée'
          : action === 'update'
            ? 'mise à jour'
            : 'réussie';
    const msg = `${capitalise(entity)} ${verb} avec succès${extra ? ` — ${extra}` : ''}`;
    this.toastSuccess(msg);
    return msg;
  },

  errorAction(action, entityKey = 'survey', details = '') {
    const entity = Lexique[entityKey] || entityKey;
    const act =
      action === 'delete'
        ? 'la suppression'
        : action === 'create'
          ? 'la création'
          : action === 'update'
            ? 'la mise à jour'
            : "l'opération";
    const msg = `Erreur lors de ${act} de ${entity}${details ? ` — ${details}` : ''}`;
    this.toastError(msg);
    return msg;
  },
};
